import type { Identifier } from "ra-core";

import type { AppRole } from "../types";

/** Almikia Epic PL (TASK-060/061): the two kinds of pilot feedback. */
export const FEEDBACK_KINDS = ["problema", "sugerencia"] as const;
export type FeedbackKind = (typeof FEEDBACK_KINDS)[number];

/** Triage status of a report, changed only by direccion. */
export const FEEDBACK_STATUSES = ["nuevo", "revisado", "resuelto"] as const;
export type FeedbackStatus = (typeof FEEDBACK_STATUSES)[number];

/**
 * A row of `feedback_reports` (append-only). The author sends only `kind`,
 * `message` and the captured screen context; `id`, `created_at`, `created_by`
 * and `status` are server-set and the author can never read the row back.
 */
export type FeedbackReport = {
  id: Identifier;
  created_at: string;
  created_by: Identifier;
  kind: FeedbackKind;
  message: string;
  screen_path: string;
  screen_title: string;
  viewport: string;
  app_locale?: string | null;
  user_agent?: string | null;
  status: FeedbackStatus;
  reviewed_by?: Identifier | null;
  reviewed_at?: string | null;
  direccion_note?: string | null;
};

/** The fields the author's client is allowed to send on insert. */
export type FeedbackReportInput = Pick<
  FeedbackReport,
  | "kind"
  | "message"
  | "screen_path"
  | "screen_title"
  | "viewport"
  | "app_locale"
  | "user_agent"
>;

/** A row of `feedback_reports_summary` (direccion only): the report plus author/reviewer names. */
export type FeedbackReportSummary = FeedbackReport & {
  author_first_name: string;
  author_last_name: string;
  author_role: AppRole;
  reviewer_first_name?: string | null;
  reviewer_last_name?: string | null;
};
